import React from 'react';
import PropTypes from 'prop-types';

import Assignees from './assignees';
import Approvers from './approvers';

export default function ApprovalDetails({ approvalWorkflow, completedApprovalTasks, uncompletedApprovalTasks }) {
  return (
    <div className="d-flex py-2">
      {completedApprovalTasks.length > 0 && <Approvers tasks={completedApprovalTasks} />}
      <Assignees approvalWorkflow={approvalWorkflow} tasks={uncompletedApprovalTasks} />
    </div>
  );
}

ApprovalDetails.propTypes = {
  approvalWorkflow: PropTypes.object.isRequired,
  completedApprovalTasks: PropTypes.array.isRequired,
  uncompletedApprovalTasks: PropTypes.array.isRequired,
};
